var p = Object.defineProperty;
var m = (i, e, t) => e in i ? p(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var h = (i, e, t) => m(i, typeof e != "symbol" ? e + "" : e, t);
import { escape as d } from "./utils/escape.js";
import { hasNativeEmojiSupport as f, substituteUnicodeForColonified as b } from "./utils/emoji.js";
import { encodeAttributes as x } from "./utils/attribute-encoding.js";
import { MENTION_CLASS as n } from "./constants.js";
class z {
  constructor(e, t) {
    h(this, "schema");
    h(this, "config");
    h(this, "text");
    h(this, "nodeNameMap", {
      bold: "b",
      italic: "i",
      anchor: "a",
      code: "code",
      span: "span"
    });
    this.schema = e, this.config = t, this.text = "";
  }
  serializeNode(e) {
    const t = [];
    return e.content.forEach((a) => {
      let s = a.marks || [];
      switch (s = this.filterSerializableMarks(s), this.maybeCloseMarks(t, s), a.type) {
        case this.schema.nodes.hardBreak:
          this.text += "<br>";
          break;
        case this.schema.nodes.text:
          this.maybeOpenMarks(t, s), this.serializeText(a);
          break;
        case this.schema.nodes.template:
          this.maybeOpenMarks(t, s), this.serializeTemplate(a);
          break;
        case this.schema.nodes.mention:
          this.serializeMention(a);
          break;
        case this.schema.nodes.aiPromptData:
          this.serializeAiPromptData(a);
          break;
        case this.schema.nodes.marker:
          break;
        case this.schema.nodes.inlineImage:
          this.serializeImage(a);
          break;
        default:
          throw new Error("Invalid node type in text");
      }
    }), this.maybeCloseMarks(t, []), this.text;
  }
  filterSerializableMarks(e) {
    return e.filter((t) => t.type.spec.serializable !== !1);
  }
  maybeCloseMarks(e, t) {
    if (e.filter((r) => !t.includes(r)).length === 0)
      return;
    const s = e.pop();
    if (!s)
      throw new Error("unreachable");
    this.addClosingTag(s.type), this.maybeCloseMarks(e, t);
  }
  maybeOpenMarks(e, t) {
    t.filter((s) => !e.includes(s)).forEach((s) => {
      e.push(s), this.addOpeningTag(s);
    });
  }
  serializeText(e) {
    let t = e.text ?? "";
    f() || (t = b(t)), this.text += this.escape(t);
  }
  serializeTemplate(e) {
    this.text += `{{${this.escape(e.attrs.attributePath)}`, e.attrs.fallback && (this.text += `|fallback:"${this.escape(e.attrs.fallback)}"`), this.text += "}}";
  }
  serializeMention(e) {
    this.text += `<a class="${n}" href="${this.escape(e.attrs.uri)}">${this.escape(
      e.attrs.name
    )}</a>`;
  }
  serializeAiPromptData(e) {
    let t = "<span data-ai-prompt-data";
    Object.entries(e.attrs).forEach(([a, s]) => {
      if (s) {
        const r = a.replace(/[A-Z]/g, (c) => `-${c.toLowerCase()}`);
        t += ` data-prompt-data-${r}="${this.escape(s)}"`;
      }
    }), this.text += `${t}></span>`;
  }
  serializeImage(e) {
    const { displayWidth: t, width: a, src: s, linkUrl: r, text: c, className: l } = e.attrs;
    let o = `<img class="${n} inline-image" src="${this.escape(s)}" width="${// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    t || a}"${c ? ` alt="${this.escape(c)}"` : ""}${l ? ` data-class-name="${this.escape(l)}"` : ""}>`;
    r && (o = `<a href="${this.escape(r)}">${o}</a>`), this.text += o;
  }
  addClosingTag(e) {
    this.text += `</${this.nodeNameMap[e.name]}>`;
  }
  addOpeningTag(e) {
    this.text += `<${this.nodeNameMap[e.type.name]}`, e.attrs && this.addAttrs(e), this.text += ">";
  }
  addAttrs(e) {
    Object.keys(e.attrs).forEach((t) => {
      const a = x(e.attrs[t]), s = this.escape(a);
      s && (this.text += ` ${t}="${s}"`);
    });
  }
  escape(e) {
    return d(e);
  }
}
export {
  z as TextSerializer
};
